/* ------------------------------------------------------------------
   LUS · mega-menu guard.

   The theme opens the mega panel on hover and only closes it on
   `mouseleave` of the nav or on Escape. If the pointer leaves the
   window, the page scrolls under it, or a hero slide swaps the element
   the pointer was over, that mouseleave can never fire and the panel
   stays open — which reads as the header suddenly being several times
   taller.

   This file only ever removes the `open` class; it never opens
   anything, so it cannot break the normal hover behaviour.
   ------------------------------------------------------------------ */
(function () {
  var D = document, W = window;

  function boot() {
    var nav = D.getElementById('navbar') || D.querySelector('.navbar');
    if (!nav) return;
    var mega = D.getElementById('mega') || nav.querySelector('.mega');
    var shop = nav.querySelector('[aria-expanded]');

    var inside = false;
    var timer = null;

    function close() {
      if (!nav.classList.contains('open')) return;
      nav.classList.remove('open');
      if (shop) shop.setAttribute('aria-expanded', 'false');
    }

    function over(el) {
      return !!el && (nav.contains(el) || (mega && mega.contains(el)));
    }

    D.addEventListener('pointermove', function (e) {
      inside = over(e.target);
      if (inside) {
        if (timer) { clearTimeout(timer); timer = null; }
      } else if (!timer) {
        timer = setTimeout(function () { timer = null; if (!inside) close(); }, 700);
      }
    }, { passive: true });

    D.addEventListener('pointerdown', function (e) {
      if (!over(e.target)) close();
    }, { passive: true });

    W.addEventListener('scroll', function () {
      if (!inside) close();
    }, { passive: true });

    D.addEventListener('mouseleave', close);
    W.addEventListener('blur', close);
    D.addEventListener('visibilitychange', function () {
      if (D.hidden) close();
    });
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
